<template>
    <article :class="[classes.teaser.teaser, { [classes.teaser.teaserHasImage]: hasImage }]">
        <div v-if="hasImage" :class="classes.teaser.image" v-html="item.image"></div>
        <div :class="classes.teaser.body">
            <h3 :class="classes.teaser.title">
                <a :href="href" :class="classes.teaser.link" @click="emit('select', item)">{{ item.title }}</a>
            </h3>
            <p v-if="hasSnippet" :class="classes.teaser.snippet">
                <!-- index keys are fine here: snippet segments have no identity and never reorder -->
                <template v-for="(segment, index) in item.snippet" :key="index">
                    <mark v-if="segment.highlight" :class="classes.teaser.highlight">{{ segment.text }}</mark>
                    <template v-else>{{ segment.text }}</template>
                </template>
            </p>
            <span :class="classes.teaser.url">{{ url }}</span>
        </div>
    </article>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Item, TeaserProps } from '../../core/types'
import { displayUrl, safeHref } from '../../core/url'
import { useClasses } from '../composables/useClasses'

const props = defineProps<TeaserProps>()

const emit = defineEmits<{
    select: [item: Item]
}>()

const classes = useClasses()
const hasImage = computed(() => props.item.image !== null && props.item.image !== '')
const hasSnippet = computed(() => props.item.snippet.length > 0)
const url = computed(() => displayUrl(props.item.link))
const href = computed(() => safeHref(props.item.link))
</script>
